<div class="row" style="min-height: 500px;">
  <div class="col">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-12">
            <div class="tablewrap">
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.userName' | translate }}<span class="red">*</span></p>
                  <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
                    <input type="text" class="form-control text-end" placeholder="..." [ngModel]="username"
                           (ngModelChange)="onUsername($event)">
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.lastName' | translate }}<span class="red">*</span></p>
                  <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
                    <input type="text" class="form-control text-end" placeholder="..." [ngModel]="lastname"
                           (ngModelChange)="onLastname($event)">
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.firstName' | translate }}<span class="red">*</span></p>
                  <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
                    <input type="text" class="form-control text-end" placeholder="..." [ngModel]="firstname"
                           (ngModelChange)="onFirstname($event)">
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{'lang.globals.email' | translate}}</p>
                  <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
                    <input type="text" class="form-control text-end" placeholder="..." [ngModel]="email"
                           (ngModelChange)="onEmail($event)">
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb" *ngIf="displayMailComponent">
                <div class="mt-3 row-body d-flex flex-column flex-md-row justify-content-between min-width-zero header">
                  <p class="w-100 " (click)="onWelcomeMail()"><label class="form-label" for="mail">Welcome&nbsp;Mail</label></p>
                  <p class="w-25 form-check form-switch d-flex justify-content-end">
                    <input id="mail" type="checkbox" class="form-check-input" role="switch"
                           [ngModel]="welcomeMail"
                           (ngModelChange)="onWelcomeMail()">
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bbl">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                </div>
              </div>
              <div class="d-flex flex-row">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100 tr"></p>
                  <p class="w-100 tr">
                    <button class="btn btn-primary mr-2" [disabled]="!firstname || !lastname || !username"
                            (click)="ok()">{{'lang.globals.ok' | translate}}</button>
                    <button class="btn btn-secondary"
                            (click)="cancel()">{{'lang.globals.cancel' | translate}}</button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
